import {
  useKeyUserLibraryContinueSeries,
  useKeyULContinueSeriesV2,
  useKeyUserLibraryFavorites,
  useKeyUserLibraryMyList,
  useQueryUserLibraryMyList,
  useQueryULMyListV3,
} from '@ifit/gateway-wolf-athenaeum-service';
import {
  useMembershipTypeDisabler,
  useRequiredRequestOptions,
} from '../query-options';
import { useInvalidateOnCallJavaScript } from '../native-bridge-refresh';
import { useEquipmentType } from '../equipment-type';
import { useModality } from '../use-modality';
import { useFeatureFlags } from '../../../helpers/good-cop-helper';

const featureFlag = 'featureflag://flag?key=challenge-store&type=bool';

export const useMyListRowQuery = (enabled: boolean) => {
  const opts = useRequiredRequestOptions();

  useInvalidateOnCallJavaScript('RefreshFavorites', useKeyUserLibraryMyList);
  useInvalidateOnCallJavaScript('RefreshFavorites', useKeyUserLibraryFavorites);
  useInvalidateOnCallJavaScript(
    'RefreshFavorites',
    useKeyUserLibraryContinueSeries,
  );
  return useQueryUserLibraryMyList(
    { ...opts },
    {
      cacheTime: 5000,
      ...useMembershipTypeDisabler(),
      enabled,
    },
  );
};

export const useMyListRowQueryV3 = (enabled: boolean) => {
  const { equipmentType, isLoading } = useEquipmentType();
  const modality = useModality(equipmentType);
  const opts = { ...useRequiredRequestOptions(), modality };
  const isEnabled = !!enabled && !isLoading;
  useInvalidateOnCallJavaScript('RefreshFavorites', useKeyUserLibraryMyList);
  useInvalidateOnCallJavaScript('RefreshFavorites', useKeyUserLibraryFavorites);
  useInvalidateOnCallJavaScript('RefreshFavorites', useKeyULContinueSeriesV2);
  return useQueryULMyListV3(
    { ...opts },
    {
      cacheTime: 5000,
      ...useMembershipTypeDisabler(),
      enabled: isEnabled,
    },
  );
};

export const useGetMyListRow = () => {
  const featureFlags = useFeatureFlags([featureFlag]);
  const v3Enabled = featureFlags[featureFlag]
    ? (featureFlags[featureFlag] as boolean)
    : false;
  const v3Results = useMyListRowQueryV3(v3Enabled);
  const results = useMyListRowQuery(!v3Enabled);
  return v3Enabled ? v3Results : results;
};
